
import React, { useState } from 'react';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ButtonGroup,
    CustomInput,
    FormGroup
} from 'reactstrap'
import { useForm, useWatch } from 'react-hook-form';
import { useMutation } from 'react-query';
import { useTranslation, Trans } from 'react-i18next';
import { toast } from 'components/Shared/Toast';

import { fetcher } from 'api/client';
// import {linkContract} from 'api/actions/contracts';
import { duplicateContract } from 'api/actions/contracts';
import { useHistory } from 'react-router';

function RenewContractModal({ isOpen, toggle, values, register, control, contract, onRenew }) {
    const { t } = useTranslation();

    const source = useWatch({
        control,
        name: 'source',
        defaultValue: 'document'
    });

    return (
        <Modal isOpen={isOpen} centered>
            <ModalHeader>
                {t('contracts.renew.title')}
            </ModalHeader>
            <ModalBody>
                <p>
                    <Trans
                        i18nKey="contracts.renew.message"
                        values={{ contractName: contract.name }}
                        components={{ b: <strong /> }}
                    />.
                </p>
                <div className="mb-3">
                    <p className="font-weight-bold">¿A partir de donde quieres renovar el documento?</p>
                    <CustomInput name="source" type="radio" value="document" id="sourceDocument" label="Este documento"  innerRef={register} /> 
                    <CustomInput name="source" type="radio" value="template" id="sourceTemplate" label="Una plantilla" innerRef={register} />
                </div>
                {source === 'document' &&
                    <>
                        <p className="font-weight-bold">{t('contracts.duplicate.options')}:</p>
                        <FormGroup>
                            <CustomInput type="checkbox" id="keepParticipants" name="keepParticipants" innerRef={register} label={t('contracts.duplicate.keepParticipants')}/> 
                            <CustomInput type="checkbox" id="keepVariables" name="keepVariables" innerRef={register} label={t('contracts.duplicate.keepVariables')}/> 
                            <CustomInput type="checkbox" id="keepAttachments" name="keepAttachments" innerRef={register} label={t('contracts.duplicate.keepAttachments')}/> 
                        </FormGroup>
                    </>
                }
            </ModalBody>
            <ModalFooter className="text-center">
                <ButtonGroup className="d-flex flex-grow-1">
                    <Button color="secondary" onClick={toggle}>
                        {t('contracts.reference.cancel')}
                    </Button>
                    <Button color="primary" type="button" onClick={onRenew}>
                        {t('contracts.renew.renew')}
                    </Button>
                </ButtonGroup>
            </ModalFooter>
        </Modal>
    )
}

function RenewContractModalContainer({ isOpen, toggle, onSave = () => { }, contract, onOpenCreateContract }) {
    const { t } = useTranslation();
    const history = useHistory();

    const { mutate: mutateDuplicate } = useMutation((payload) => fetcher(duplicateContract(payload)), {
        onSuccess: (data) => {
            if (data._id) {
                toast.success(t('contracts.options.success_renew'))
                onSave()
                toggle()
                history.push(`/contracts/editor/${data._id}`)
            } 
        }, onError: (error) => {
            toast.error(t(`errors.${error.message}`))
        }
    })
    const methods = useForm({
        defaultValues: { 
            keepVariables: true, 
            keepParticipants: true, 
            keepAttachments: true,
            source: 'document'
        }
    });

    const handleRenew = async (data) => {
        if (data.source === 'document') {
            mutateDuplicate({
                contractId: contract._id,
                setNewContractAsChild: true,
                keep_participants: data.keepParticipants,
                keep_variables: data.keepVariables,
                keet_attachments: data.keepAttachments
            })
        } else if (data.source === 'template') {
            onOpenCreateContract({ referenceId: contract.isChild ? contract.parentReference : contract._id , options: { 
                copyPartInfo: true, 
                copyMilestones: true,
                initialDocumentType: 'template'
              }  
            })
            toggle()
        }
    }


    return (
        <RenewContractModal
            isOpen={isOpen}
            toggle={toggle}
            contract={contract}
            {...methods}
            onRenew={methods.handleSubmit(handleRenew)}
        />
    )
}

export default RenewContractModalContainer;